import { useState } from "react";
import { authApi } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await authApi.forgot(email);
      setSent(true);
      toast.success("If the email exists, a reset link has been sent");
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-6">
      <div className="max-w-md w-full bg-white border border-canvas-border rounded-2xl p-10 shadow-soft">
        <h1 className="font-display text-2xl font-bold text-espresso mb-2">Reset your password</h1>
        <p className="text-espresso-ink/70 text-sm mb-8">Enter your email and we&apos;ll send you a link.</p>
        {sent ? (
          <div className="p-4 bg-status-synced/10 border border-status-synced/20 text-status-synced rounded-lg text-sm" data-testid="forgot-success">
            Check your inbox for the reset link.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-white border border-canvas-border rounded-lg brand-focus"
              placeholder="you@company.com"
            />
            <button data-testid="forgot-submit" className="w-full py-3 bg-espresso text-canvas rounded-lg font-semibold hover:bg-espresso-light transition-colors">Send reset link</button>
          </form>
        )}
        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-gold hover:text-gold-light">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
